export const selectRegretData = (state) => state.regretDashboard?.regretData;
export const selectLoading = (state) => state.regretDashboard?.loading;
export const selectError = (state) => state.regretDashboard?.error;
export const selectStats = (state) => {
  const apiData = selectRegretData(state);
  if (!apiData) return [];
  
  return [
    {
      title: "Regret Rate",
      value: `${((apiData.regretOnly / apiData.totalCasesTracked) * 100).toFixed(1)}%`,
      bgColor: "#fee2e2",
      textColor: "#dc2626"
    },
    {
      title: "Regret Only (No Action Taken)",
      value: apiData.regretOnly?.toLocaleString() || 0,
      bgColor: "#fef3c7",
      textColor: "#d97706"
    },
    {
      title: "Regret + Replacement Created (Mapped)",
      value: apiData.regretReplacementMapped?.toLocaleString() || 0,
      bgColor: "#dbeafe",
      textColor: "#2563eb"
    },
    {
      title: "Regret + Replacement Fresh Order (Unmapped)",
      value: apiData.regretReplacementFreshOrder?.toLocaleString() || 0,
      bgColor: "#e0e7ff",
      textColor: "#5b21b6"
    },
    {
      title: "Not Found Cases (Marked by Sampler)",
      value: apiData.notFound?.toLocaleString() || 0,
      bgColor: "#f3e8ff",
      textColor: "#7c3aed"
    },
    {
      title: "Rejected by Lab",
      value: apiData.rejectedByLab?.toLocaleString() || 0,
      bgColor: "#fecaca",
      textColor: "#b91c1c"
    }
  ];
};

export const selectCommonReasons = (state) => {
  const apiData = selectRegretData(state);
  if (!apiData) return [];
  
  const rawCommonReasons = (apiData.commonRegretReasons || []).map((reason, index) => ({
    label: reason.reason,
    count: reason.count,
    percent: `${reason.percentage}%`,
    percentage: reason.percentage 
  }));
  
  return rawCommonReasons
    .sort((a, b) => b.percentage - a.percentage)
    .slice(0, 8);
};

export const selectKpis = (state) => {
  const apiData = selectRegretData(state);
  if (!apiData) return null;
  
  return {
    totalCasesTracked: apiData.totalCasesTracked?.toLocaleString() || 0,
    resolutionRate: `${apiData.resolutionRate}%`
  };
};